import React from "react";

type Props = {
  children: React.ReactNode;
};

const EditText = ({ children }: Props) => {
  return (
    <span className="font-sans font-semibold text-lg leading-5 text-primary-500">
      {children}
    </span>
  );
};

export default EditText;
